module.exports = __webpack_public_path__ + "img/a-3.f94d09b0.png";